export default "__VITE_ASSET__Dekw_dVc__"